/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Order limit per period (DAY, WEEK, MONTH). Set to null to clear.
 * @export
 * @interface UpdateCatalogItemRequestOrderLimit
 */
export interface UpdateCatalogItemRequestOrderLimit {
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogItemRequestOrderLimit
     */
    period?: UpdateCatalogItemRequestOrderLimitPeriodEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateCatalogItemRequestOrderLimit
     */
    maxQuantity?: number;
}


/**
 * @export
 */
export const UpdateCatalogItemRequestOrderLimitPeriodEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
} as const;
export type UpdateCatalogItemRequestOrderLimitPeriodEnum = typeof UpdateCatalogItemRequestOrderLimitPeriodEnum[keyof typeof UpdateCatalogItemRequestOrderLimitPeriodEnum];


/**
 * Check if a given object implements the UpdateCatalogItemRequestOrderLimit interface.
 */
export function instanceOfUpdateCatalogItemRequestOrderLimit(value: object): value is UpdateCatalogItemRequestOrderLimit {
    return true;
}

export function UpdateCatalogItemRequestOrderLimitFromJSON(json: any): UpdateCatalogItemRequestOrderLimit {
    return UpdateCatalogItemRequestOrderLimitFromJSONTyped(json, false);
}

export function UpdateCatalogItemRequestOrderLimitFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogItemRequestOrderLimit {
    if (json == null) {
        return json;
    }
    return {
        
        'period': json['period'] == null ? undefined : json['period'],
        'maxQuantity': json['maxQuantity'] == null ? undefined : json['maxQuantity'],
    };
}

export function UpdateCatalogItemRequestOrderLimitToJSON(value?: UpdateCatalogItemRequestOrderLimit | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'period': value['period'],
        'maxQuantity': value['maxQuantity'],
    };
}

